'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$FreemiumSeed(name, seed) {
  this.L4 = null;
  this.L5 = null;
  this.L4 = name;
  this.L5 = seed;
}
export { $c_Lpresto_types$FreemiumSeed as $c_Lpresto_types$FreemiumSeed };
$p = $c_Lpresto_types$FreemiumSeed.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$FreemiumSeed;
/** @constructor */
function $h_Lpresto_types$FreemiumSeed() {
}
export { $h_Lpresto_types$FreemiumSeed as $h_Lpresto_types$FreemiumSeed };
$h_Lpresto_types$FreemiumSeed.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$FreemiumSeed) && ((this.L4 === x$0.L4) && (this.L5 === x$0.L5))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "FreemiumSeed";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.L4;
  }
  if ((n === 1)) {
    return this.L5;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$FreemiumSeed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jS)));
}
export { $isArrayOf_Lpresto_types$FreemiumSeed as $isArrayOf_Lpresto_types$FreemiumSeed };
var $d_Lpresto_types$FreemiumSeed = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$FreemiumSeed, "presto.types$FreemiumSeed", ({
  jS: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$FreemiumSeed as $d_Lpresto_types$FreemiumSeed };
//# sourceMappingURL=presto.types$-Freemium-Seed.js.map
